import Yup from '../../../../helpers/custom-yup'
import { paymentFieldsYupSchema } from '../../../../components/form-components/payment-fields/payment-fields.component'

export const validationSchema = Yup.object().shape({
	isGift: Yup.bool().required(),
	cpf: Yup.string().when(['isGift'], {
		is: true,
		then: Yup.string()
			.cpf()
			.required('Preencha o CPF da pessoa que irá receber os pontos'),
		otherwise: Yup.string().cpf()
	}),
	points: Yup.number().required('Informe a quantidade de pontos'),
	acceptTerms: Yup.mixed()
		.oneOf([true], 'Aceite os termos')
		.required('Aceite os termos'),
	...paymentFieldsYupSchema
})
